module.exports = __webpack_public_path__ + "static/img/00323v.5ccfbe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/00323v.jpg
// module id = M9Cm
// module chunks = 1